import React, { useEffect, useState, memo } from 'react';
import { useSelector } from 'react-redux';
import axiosInstance from '../../utils/axiosConfig';
import GiftCard from './GiftCard';
import GiftAdmin from './GiftAdmin';
import giftSvg from '../../assets/gift.svg';
import giftValueSvg from '../../assets/gift-value.svg';
import LoaderInside from '../LoaderInside';

const GiftComponent = memo(() => {
    const [gifts, setGifts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [userPosition, setUserPosition] = useState(0);

    const adminMode = useSelector((state) => state.adminMode.adminMode);

    // Добавляем функцию для предзагрузки изображений
    const preloadImages = async () => {
        const images = [giftSvg, giftValueSvg];
        try {
            await Promise.all(
                images.map((src) => {
                    return new Promise((resolve, reject) => {
                        const img = new Image();
                        img.src = src;
                        img.onload = resolve;
                        img.onerror = reject;
                    });
                })
            );
            setImagesLoaded(true);
        } catch (error) {
            console.error('Ошибка при загрузке изображений:', error);
            setImagesLoaded(true); // Всё равно показываем контент
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Запускаем предзагрузку изображений параллельно с запросом
                preloadImages();

                const { data: result } = await axiosInstance.post('/gifts/get');

                if (result.success) {
                    const sortedGifts = result.data.sort((a, b) => a.pointsRequired - b.pointsRequired);
                    setGifts(sortedGifts);

                    // Добавляем логирование для отладки и проверяем тип
                    const position = result.userPosition !== null ? result.userPosition : 0;
                    setUserPosition(position);
                } else {
                    throw new Error(result.error || 'Ошибка получения данных');
                }
            } catch (err) {
                setError(err.message);
                console.error('Ошибка при загрузке данных:', err);
            } finally {
                setLoading(false);
            }
        };

            fetchData();
    }, []);

    if (loading || !imagesLoaded) {
        return (
            <div className="loader-container">
                <LoaderInside />
            </div>
        );
    }

    if (error) {
        return <div className="error-message">Ошибка: {error}</div>;
    }

    return (
        <>
            {adminMode ? (
                <GiftAdmin gifts={gifts} setGifts={setGifts} />
            ) : (
                <>
                    <div className="gift-main">
                        <div className="gift-card-header">ПОЗИЦИЯ</div>
                        <div className="gift-image-container">
                            <img src={giftSvg} alt="Подарок" className="gift-image" />
                        </div>
                        <div className="gift-card-value-container">
                            <img
                                src={giftValueSvg}
                                alt=""
                                className="gift-value-background"
                            />
                            <span className="gift-card-value">
                                {userPosition !== null && userPosition !== undefined ? userPosition : '-'}
                            </span>
                        </div>
                    </div>


                    <div className="gifts-container">
                        <div className="gifts-grid">
                            {gifts.map((gift, index) => (
                                <GiftCard
                                    key={gift._id || Math.random().toString()}
                                    gift={gift}
                                    index={index}
                                />
                            ))}
                        </div>
                    </div>
                </>
            )}
        </>
    );
});

export default GiftComponent; 